import * as Style from './style';

export default function Table({ children, style }) {
  return (
    <Style.Container style={style}>
      { children }
    </Style.Container>
  );
}
